import React from 'react';
import {
  AnswerApplicationQuestionRequest,
  Question,
} from '../../../../openapi/atlantis';
import { ConfigDrivenQuestionTemplate, EnumMap } from '../../../../types';
import { ApplicationStepWithNewContent } from '../../../../utils/ConfigDrivenFormUtils';
import { safeEnumMapGet } from '../../../../utils/EnumHelper';
import ConfigDrivenQuestionContainerV2 from '../ConfigDrivenQuestionContainerV2';
import ConfigDrivenQuestionContainer from '../ConfigDrivenQuestionContainer';

interface ConfigDrivenQuestionWrapperProps {
  config: ApplicationStepWithNewContent<Question>;
  onNext: () => Promise<void>;
  onSubmit: (formData: AnswerApplicationQuestionRequest) => Promise<void>;
  onNavigateToQuestion?: (questionId: string) => Promise<void>;
}

interface ConfigDrivenQuestionTemplateProps {
  config: ApplicationStepWithNewContent<Question>;
  onNext: () => Promise<void>;
  onSubmit: (formData: AnswerApplicationQuestionRequest) => Promise<void>;
  onNavigateToQuestion?: (questionId: string) => Promise<void>;
}

const ConfigDrivenQuestionWrapper: React.FC<
  ConfigDrivenQuestionWrapperProps
> = ({ config, onNext, onSubmit, onNavigateToQuestion }) => {
  const CONFIG_DRIVEN_QUESTION_CONTAINER: EnumMap<
    ConfigDrivenQuestionTemplate,
    React.FC<ConfigDrivenQuestionTemplateProps>
  > = {
    [ConfigDrivenQuestionTemplate.TEMPLATE_1]: ConfigDrivenQuestionContainer,
    [ConfigDrivenQuestionTemplate.TEMPLATE_2]: ConfigDrivenQuestionContainerV2,
    [ConfigDrivenQuestionTemplate.TEMPLATE_3]: ConfigDrivenQuestionContainerV2, // REZEN_AGENT_1 uses V2 component
  };

  const ConfigDrivenQuestionComponent = safeEnumMapGet(
    CONFIG_DRIVEN_QUESTION_CONTAINER,
    config?.content?.style?.template as unknown as ConfigDrivenQuestionTemplate,
    CONFIG_DRIVEN_QUESTION_CONTAINER[ConfigDrivenQuestionTemplate.TEMPLATE_1],
  );

  return (
    <ConfigDrivenQuestionComponent
      config={config}
      onNext={onNext}
      onSubmit={onSubmit}
      onNavigateToQuestion={onNavigateToQuestion}
    />
  );
};

export default ConfigDrivenQuestionWrapper;
